
<div>
  <label for="optionRange"><slot>Required Selection Number</slot></label>
  <multi-input compress>
    <column>
      <a-select
        id="optionRange"
        v-model="optionRangeType"
        :options="checkboxRangeOptions"
        :disabled="disabled"
      ></a-select>
    </column>
    <column v-if="showCheckboxMin">
      <number-input
        id="checkbox_range_min"
        v-model="model.checkbox_range_min"
        :min="min"
        :max="model.checkbox_range_max"
        :placeholder="minPlaceholder"
        :disabled="disabled"
        :key="`${model.client_id}_min`"
      ></number-input>
    </column>
    <column v-if="showCheckboxMax">
      <number-input
        id="checkboxRangeMax"
        v-model="model.checkbox_range_max"
        @blur="maxChanged()"
        :min="model.checkbox_range_min"
        :max="max"
        placeholder="Max"
        :disabled="disabled"
        :key="`${model.client_id}_max`"
      ></number-input>
    </column>
  </multi-input>
</div>
